import { render, staticRenderFns } from "./SetupGuide.vue?vue&type=template&id=4720c48b&scoped=true"
import script from "./SetupGuide.vue?vue&type=script&lang=js"
export * from "./SetupGuide.vue?vue&type=script&lang=js"
import style0 from "./SetupGuide.vue?vue&type=style&index=0&id=4720c48b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4720c48b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4720c48b')) {
      api.createRecord('4720c48b', component.options)
    } else {
      api.reload('4720c48b', component.options)
    }
    module.hot.accept("./SetupGuide.vue?vue&type=template&id=4720c48b&scoped=true", function () {
      api.rerender('4720c48b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/External/Shoplazza/components/SetupGuide.vue"
export default component.exports